import { SensorOrSubSensorInfoWithoutSection } from '@components/cockpit/panels/monitoring/monitoring.types';
import { isSensorOrSubSensorInfoOfType } from '@components/cockpit/panels/monitoring/monitoring.utils';

import { SubSensorTypeEnum } from '@/types/sensor/sensors';

import CabinetMaintenanceLinks from './CabinetMaintenanceLinks';

type SpecificMaintenanceLinksProps = {
  sensorOrSubSensorInfo: SensorOrSubSensorInfoWithoutSection;
  replayMode?: boolean;
};

export default function SpecificMaintenanceLinks({ sensorOrSubSensorInfo }: Readonly<SpecificMaintenanceLinksProps>) {
  switch (sensorOrSubSensorInfo.type) {
    case SubSensorTypeEnum.AUTOMATON_CABINET: {
      if (isSensorOrSubSensorInfoOfType(sensorOrSubSensorInfo, SubSensorTypeEnum.AUTOMATON_CABINET)) {
        return <CabinetMaintenanceLinks sensorOrSubSensorInfo={sensorOrSubSensorInfo} />;
      }
      return null;
    }
    default:
      return null;
  }
}
